import { ModifierKey } from '../types';
import { Base } from './base';
export class ScrollerManager extends Base {
    get widgetOptions() {
        return this.options.scroller;
    }
    get pannable() {
        return this.widgetOptions && this.widgetOptions.pannable === true;
    }
    init() {
        this.widget = this.graph.hook.createScroller();
        this.autoSetCursor();
        this.graph.on('blank:mousedown', ({ e }) => {
            if (this.widget &&
                this.pannable &&
                ModifierKey.test(e, this.widgetOptions.modifiers) &&
                this.graph.hook.allowPanning(e)) {
                this.widget.startPanning(e);
            }
        });
        if (this.widget) {
            this.widget.center();
        }
    }
    autoSetCursor() {
        var _a;
        const options = this.widgetOptions;
        if (options.cursor == null) {
            const cursor = options.pannable ? 'grab' : '';
            (_a = this.widget) === null || _a === void 0 ? void 0 : _a.setCursor(cursor, { silent: true });
        }
    }
    enablePanning() {
        if (!this.pannable) {
            this.widgetOptions.pannable = true;
            if (ModifierKey.equals(this.graph.options.scroller.modifiers, this.graph.options.selecting.modifiers)) {
                this.graph.selection.disableRubberband();
            }
        }
        this.autoSetCursor();
    }
    disablePanning() {
        if (this.pannable) {
            this.widgetOptions.pannable = false;
        }
        this.autoSetCursor();
    }
    lock() {
        if (this.widget) {
            this.widget.lock();
        }
    }
    unlock() {
        if (this.widget) {
            this.widget.unlock();
        }
    }
    update() {
        if (this.widget) {
            this.widget.update();
        }
    }
    setCursor(cursor) {
        if (this.widget) {
            this.widget.setCursor(cursor);
        }
    }
}
//# sourceMappingURL=scroller.js.map